// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3FkFW","buttons":"RemoveExpirationActionButtons_buttons__19a77"};